import { render, staticRenderFns } from "./UserRemark.vue?vue&type=template&id=4f065e4a&scoped=true&"
import script from "./UserRemark.vue?vue&type=script&lang=js&"
export * from "./UserRemark.vue?vue&type=script&lang=js&"
import style0 from "./UserRemark.vue?vue&type=style&index=0&id=4f065e4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f065e4a",
  null
  
)

export default component.exports